import { FormControl, MenuItem, Select, SxProps, Typography } from '@mui/material';
import { useContext, useEffect } from 'react';
import { OnlyStrugglesTtsProviders } from '../../../hooks/useTtsReferenceModels';
import { SettingsContext } from '../../../store/SettingsContext';

type Props = {
    ttsProvider: OnlyStrugglesTtsProviders | undefined | null;
    handleTtsProviderChange: (provider: OnlyStrugglesTtsProviders) => void;
    size?: 'small' | 'medium';
    disabled?: boolean;
    sx?: SxProps;
};

const TtsProviderSelector = (props: Props) => {
    const { ttsProvider, handleTtsProviderChange, size, disabled, sx } = props;
    const settingsContext = useContext(SettingsContext);

    // Check if the ttsProvider is set, if not, set it to the default provider from settingsContext
    useEffect(() => {
        if (!ttsProvider) {
            handleTtsProviderChange(settingsContext.tts.defaultProvider);
        }
    }, [ttsProvider, settingsContext.tts.defaultProvider, handleTtsProviderChange]);

    return (
        <FormControl fullWidth>
            <Select
                fullWidth
                variant="outlined"
                size={size}
                disabled={disabled}
                value={ttsProvider || settingsContext.tts.defaultProvider}
                onChange={e => {
                    handleTtsProviderChange(e.target.value as OnlyStrugglesTtsProviders);
                }}
                sx={sx}
            >
                {settingsContext.tts.providers.map(provider => (
                    <MenuItem key={provider.id} value={provider.id}>
                        <Typography variant="body1">{provider.name}</Typography>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default TtsProviderSelector;
